import { styled } from 'styled-components'
import HomePageVideo from 'pages/HomePage/Components/HomePageVideo/HomePageVideo'
import { heroVideoStyles } from '../heroSection.styles'

export const Video = styled(HomePageVideo)`
  ${heroVideoStyles}
`
